export default "__VITE_ASSET__Cv$jFQXG__"